import React, { useEffect, useState } from 'react';
import classes from "./SelectCaptainAndViceCaptain.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import { FaArrowLeft, FaXmark } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import { editUserTeamApi, saveUserTeamApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment-timezone";
import { toast } from 'react-toastify';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { useTranslation } from 'react-i18next';

const SelectCaptainAndViceCaptain = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [matchDetails, setMatchDetails] = useState(null);
    const [time, setTime] = useState(null);
    const [loading, setLoading] = useState(false);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [playModal, setPlayModal] = useState(false);

    const { selectedLanguage } = useSelector(state => state.languageSlice);


    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                navigate("/home");
                toast.info("Match Started! You cannot create a team in this match now!");
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            // return `${hours}h ${minutes}m ${seconds}s`;
            setTime(`${hours}h ${minutes}m ${seconds}s`)
            // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (matchDetails) {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);

            return () => {
                clearInterval(intervalId);
            }
        }
    }, [matchDetails]);

    useEffect(() => {
        setSelectedPlayers(location?.state?.selectedPlayers);
        setMatchDetails(location?.state?.matchDetails);
    }, [location.state]);

    console.log(matchDetails, "md");
    console.log(selectedPlayers, 'sp');

    const handlePlayerSelect = (selectedPlayer, type) => {
        const updatedPlayers = selectedPlayers.map(player => {
            if (player.id === selectedPlayer.id) {
                // Toggle role if same player clicked again
                return {
                    ...player,
                    captain: type === "captain" ? !player.captain : false,
                    viceCaptain: type === "viceCaptain" ? !player.viceCaptain : false
                };
            } else {
                // Remove same role from other players
                return {
                    ...player,
                    captain: type === "captain" ? false : player.captain,
                    viceCaptain: type === "viceCaptain" ? false : player.viceCaptain
                };
            }
        });

        setSelectedPlayers(updatedPlayers);
    };

    const saveTeamHandler = async () => {
        try {

            setLoading(true);

            if (location?.state?.edit) {
                // edit team api hit

                const response = await editUserTeamApi(matchDetails?.match_fixture_id, selectedPlayers,
                    // moment.utc(matchDetails?.match_date_time),
                    matchDetails?.match_date_time,
                    matchDetails?.match_venue_name, matchDetails?.match_venue_city, matchDetails?.league_id, matchDetails?.league_name, matchDetails?.league_image, matchDetails?.home_team_id, matchDetails?.home_team_name, matchDetails?.home_team_image, matchDetails?.away_team_id, matchDetails?.away_team_name, matchDetails?.away_team_image, userDetails?.token);
                console.log(response, 'response...');
            }
            else {
                const response = await saveUserTeamApi(matchDetails?.match_fixture_id, selectedPlayers,
                    // moment.utc(matchDetails?.match_date_time),
                    matchDetails?.match_date_time,
                    matchDetails?.match_venue_name, matchDetails?.match_venue_city, matchDetails?.league_id, matchDetails?.league_name, matchDetails?.league_image, matchDetails?.home_team_id, matchDetails?.home_team_name, matchDetails?.home_team_image, matchDetails?.away_team_id, matchDetails?.away_team_name, matchDetails?.away_team_image, userDetails?.token);
                console.log(response, 'response...');

            }


            setLoading(false);

            navigate("/fantasy-game", {
                state: {
                    match_fixture_id: matchDetails?.match_fixture_id
                }
            })
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                setLoading(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
                console.log(error, 'error---');
            }
        }
    }

    return (
        <Layout>
            <SubLayout>
                <div className={classes.header}>
                    <div className={classes.header_nav}>
                        <div className={classes.header_nav_container}>
                            <button type='button' className={classes.back_button}>
                                <FaArrowLeft className={classes.back_icon} onClick={() => navigate("/home")} />
                            </button>
                            <div className={classes.header_text_container}>
                                <p className={classes.header_text}>{location?.state?.edit ? "Edit" : "Create"} {t("44")}</p>
                                <p className={classes.header_timer}>{time} {t("45")}</p>
                            </div>

                        </div>
                        <button type='button' className={classes.header_button}
                        onClick={()=>setPlayModal(true)}
                        >
                            {t("46")}
                        </button>

                    </div>

                    <div className={classes.info_container}>
                        <p className={classes.info_text}>{t("47")}</p>
                    </div>

                    <div className={classes.point_info}>
                        <div className={classes.point_container}>
                            <div className={classes.point_sub_container}>
                                <p className={classes.point_type}>
                                    {t("48")}
                                </p>
                            </div>
                            <div className={classes.point_description}>
                                <p className={classes.point_text_info}>{t("49")}</p>
                                <p className={classes.point_text}>{t("50")}</p>

                            </div>
                        </div>

                        <div className={classes.point_container}>
                            <div className={classes.point_sub_container}>
                                <p className={classes.point_type}>
                                    {t("51")}
                                </p>
                            </div>
                            <div className={classes.point_description}>

                                <p className={classes.point_text_info}>{t("52")}</p>
                                <p className={classes.point_text}>{t("53")}</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div className={classes.players_list}>
                    {selectedPlayers?.map((item, index) => {
                        let captain = item?.captain;
                        let viceCaptain = item?.viceCaptain;
                        return (
                            <div className={`${classes.player_container}`} type='button' key={index}
                            >
                                <div className={classes.player_details}>
                                    <div className={classes.player_image_container}>
                                        <img src={item?.photo} alt={item?.name} className={classes.player_image} />
                                    </div>
                                    <div className={classes.player_details_container}>
                                        <p className={classes.player_name}>{item?.name}</p>
                                        <p className={classes.player_team_name}>{item?.teamName}</p>
                                    </div>
                                </div>

                                <div className={classes.buttons_container}>
                                    <button type='button' className={`${classes.captain_button} ${captain && classes.active}`}
                                        onClick={() => handlePlayerSelect(item, "captain")}
                                    >
                                        {t("54")}
                                    </button>
                                    <button type='button' className={`${classes.vice_captain_button} ${viceCaptain && classes.active}`}
                                        onClick={() => handlePlayerSelect(item, "viceCaptain")}
                                    >
                                        {t("55")}
                                    </button>
                                </div>

                                {/* {selected ? (
                                    <div className={classes.action_button_minus}>
                                        <FaMinus className={classes.action_icon_minus} />
                                    </div>
                                ) : (
                                    <div className={classes.action_button}>

                                        <FaPlus className={classes.action_icon} />
                                    </div>

                                )} */}
                            </div>
                        )
                    })}

                </div>

                <button type='button' className={`${classes.next_button} ${selectedPlayers.filter(data => data?.captain).length > 0 && selectedPlayers.filter(data => data?.viceCaptain).length > 0 && classes.active}`}
                    disabled={
                        (loading || (selectedPlayers.filter(data => data?.captain).length <= 0 && selectedPlayers.filter(data => data?.viceCaptain).length <= 0))}
                    onClick={() => {
                        if (selectedPlayers.filter(data => data?.captain).length > 0 && selectedPlayers.filter(data => data?.viceCaptain).length > 0) {
                            saveTeamHandler();
                        }
                    }}
                >
                    {loading ? <SmallLoader /> :
                        location?.state?.edit ? t("56") : t("57")
                    }
                </button>

                {playModal &&
                    <div className={classes.container2} onClick={() => setPlayModal(false)}>
                        <div className={classes.sub_container2} onClick={(e) => e.stopPropagation()}>
                            <div className={classes.close_btn_container2}>
                                <button type="button" className={classes.close_btn2} onClick={() => setPlayModal(false)}>
                                    <FaXmark className={classes.close_icon2} />
                                </button>
                            </div>

                            <div className={classes.msg2}>
                                <h2 className={classes.text2}>
                                    {selectedLanguage == 0 ? "How To Play?" : "Comment jouer ?"}
                                </h2>

                                <ul className={classes.paragraph2}>
                                    <li>
                                        {selectedLanguage == 0 ? "Create your team by selecting 11 players: 1 Goalkeeper, 4 Defenders, 4 Midfielders, and 2 Forwards." : "Créez votre équipe en sélectionnant 11 joueurs : 1 gardien de but, 4 défenseurs, 4 milieux de terrain et 2 attaquants."}
                                    </li>
                                    <li>
                                        {selectedLanguage == 0 ? "Choose 1 Captain and 1 Vice-Captain from your selected players." : "Choisissez 1 capitaine et 1 vice-capitaine parmi les joueurs sélectionnés."}
                                    </li>
                                    <li>
                                        {selectedLanguage == 0 ? "Players earn points based on their real match performance." : "Les joueurs gagnent des points en fonction de leurs performances réelles lors des matchs."}
                                    </li>
                                    <li>
                                        {selectedLanguage == 0 ? "Captain receives 2x (double) points." : "Le capitaine reçoit 2x (double) points."}
                                    </li>
                                    <li>
                                        {selectedLanguage == 0 ? "Vice-Captain receives 1.5x points." : "Le vice-capitaine reçoit 1,5 fois plus de points."}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }

            </SubLayout>
        </Layout>
    )
}

export default SelectCaptainAndViceCaptain